import { Component } from "@theme/component";
import { debounce, fetchConfig } from "@theme/utilities";
import { cartPerformance } from "@theme/performance";

/**
 * A custom element that displays a cart note.
 */
class CartCardMessage extends Component {
  /** @type {AbortController | null} */
  #activeFetch = null;

  /**
   * Handles updates to the cart note.
   * @param {InputEvent} event - The input event in our text-area.
   */
  updateCartMessage = debounce(async (event) => {
    if (!(event.target instanceof HTMLTextAreaElement)) return;

    const card_message = event.target.value;
    if (this.#activeFetch) {
      this.#activeFetch.abort();
    }
    const attributesToUpdate = {
      "card_message": card_message,
    };
    const abortController = new AbortController();
    this.#activeFetch = abortController;

    try {
      const config = fetchConfig("json", {
        body: JSON.stringify({ attributes: attributesToUpdate }),
      });

      await fetch(Theme.routes.cart_update_url, {
        ...config,
        signal: abortController.signal,
      });
    } catch (error) {
    } finally {
      this.#activeFetch = null;
      cartPerformance.measureFromEvent("message-update:user-action", event);
    }
  }, 200);
}

if (!customElements.get("card-message")) {
  customElements.define("card-message", CartCardMessage);
}
